import { fileTypeFromStream, fileTypeFromBuffer } from 'file-type';

export const getFileExtensionFromUri = async (uri) => {
  const response = await fetch(uri);
  const fileType = await fileTypeFromStream(response.body);
  return fileType?.ext;
};

export const getFileExtensionFromBlob = async (blob) => {
  const buffer = await blob.arrayBuffer();
  const fileType = await fileTypeFromBuffer(buffer);
  return fileType?.ext;
};
